import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const CurrencyContext = createContext();

export const useCurrency = () => useContext(CurrencyContext);

export const CurrencyProvider = ({ children }) => {
    const [currencySymbol, setCurrencySymbol] = useState('¥');

    useEffect(() => {
        const fetchMerchantInfo = async () => {
            const tg = window.Telegram.WebApp;
            try {
                const res = await axios.get('/api/merchant/info', {
                    headers: { 'x-telegram-init-data': tg.initData }
                });
                const code = res.data.currency_code || 'CNY';
                const symbols = { CNY: '¥', MYR: 'RM', THB: '฿', VND: '₫', PHP: '₱', LKR: 'Rs', AED: 'د.إ' };
                setCurrencySymbol(symbols[code] || '¥');
            } catch (err) {
                console.error('获取商家货币失败', err);
            }
        };
        fetchMerchantInfo();
    }, []);

    return (
        <CurrencyContext.Provider value={currencySymbol}>
            {children}
        </CurrencyContext.Provider>
    );
};